module.exports = "/assets/data/ea27d5dd61810781fbf702fcd316b8c1-BS15.data.json";